import './AntragField.css';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface AntragFieldV2Props {
  label: string;
  value: string | null;
  suppressLabel?: boolean;
}

export function AntragFieldV2({
  label,
  value,
  suppressLabel
}: AntragFieldV2Props) {
  const { t } = useTranslation();
  const displayValue = value ?? t('antragPrint.field.noValue');

  if (suppressLabel) {
    return (
      <div className="antrag-field__group field">
        <div className="antrag-field__value">{displayValue}</div>
      </div>
    );
  }

  return (
    <div className="antrag-field__group field">
      <label className="antrag-field__label">{label}</label>
      <div className="antrag-field__value">{displayValue}</div>
    </div>
  );
}
